module.exports = __webpack_public_path__ + "static/media/customer2.07505aa3.jpeg";